import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import formatCellValue from 'components/reporting/format_cell_value';
import { DataCard, DataTable, PillBar, PillButton } from 'components/reporting/reporting_shared_styled';
import VegaChart from 'components/reporting/vega_chart';

export default function ChartTableToggle({ chartSpec, data, title }) {
  const [view, setView] = useState('chart');
  const hasData = data && data.columns && data.rows && data.rows.length > 0;

  return (
    <ToggleContainer data-aid="chartTableToggle">
      {title && <ToggleTitle>{title}</ToggleTitle>}
      {hasData && (
        <PillBar>
          <PillButton $active={view === 'chart'} onClick={() => setView('chart')} type="button">
            <i className="fa fa-line-chart" /> Chart
          </PillButton>
          <PillButton $active={view === 'table'} onClick={() => setView('table')} type="button">
            <i className="fa fa-table" /> Table
          </PillButton>
        </PillBar>
      )}
      {view === 'chart' || !hasData ? (
        <VegaChart spec={chartSpec} />
      ) : (
        <DataCard>
          <DataTable>
            <thead>
              <tr>
                {data.columns.map(col => (
                  <th key={col}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((row, i) => (
                <tr key={i}>
                  {data.columns.map(col => (
                    <td key={col}>{formatCellValue(row[col])}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </DataTable>
        </DataCard>
      )}
    </ToggleContainer>
  );
}

ChartTableToggle.propTypes = {
  chartSpec: PropTypes.object.isRequired,
  data: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.string),
    rows: PropTypes.arrayOf(PropTypes.object),
  }),
  title: PropTypes.string,
};

const ToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const ToggleTitle = styled.div`
  color: ${p => p.theme.colors.gray700};
  font-size: var(--font-size-base);
  font-weight: ${p => p.theme.fontWeight.medium};
  padding: 4px 0;
`;
